export default __webpack_public_path__ + "static/media/ranes8.da7d4d6c.jpg";